export const SET_STATE = 'checkoutPage/paymentNetsEasy/SET_STATE';
export const SET_FETCHING_PAYMENT = 'checkoutPage/paymentNetsEasy/SET_FETCHING_PAYMENT';
export const SET_PAYMENT = 'checkoutPage/paymentNetsEasy/SET_RESPONSE';
export const RESET_PAYMENT_NETS_EASY = 'checkoutPage/paymentNetsEasy/RESET_PAYMENT_NETS_EASY';
